import React from 'react';
import * as styles from './styles/styles.module.scss';
import { wrapEventHandler } from '../../../utils/handlers';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { getTrailLocationUrl, getTrailLocationInfo } from '../../../utils/location_parsing';

const { findRecordFieldWithLocale } = LanguageSupportUtil;

const getDisplayName = (trail, context) => {
  let displayName;
  const localizedAreaName = findRecordFieldWithLocale(trail, 'area_name', context.languageRegionCode);
  if (localizedAreaName) {
    displayName = localizedAreaName;
  } else if (trail.park_name) {
    displayName = trail.park_name;
  } else if (trail.city_name) {
    displayName = findRecordFieldWithLocale(trail, 'city_name', context.languageRegionCode);
    if (trail.state_name != '' && trail.state_name != null) {
      displayName += (displayName == '' ? '' : ', ') + findRecordFieldWithLocale(trail, 'state_name', context.languageRegionCode);
    }
    if (trail.country_name != '' && trail.country_name != null && trail.country_id != 313 && trail.country_id != 139) {
      displayName += (displayName == '' ? '' : ', ') + findRecordFieldWithLocale(trail, 'country_name', context.languageRegionCode);
    }
  }
  return displayName;
};

/**
 * wrapLocationClick wraps the CardLocation link's onClick handler. At the time
 * the event is fired the trail's area information will be parsed and the
 * preferred trail location information will be sent to handleClick.
 *
 * @param {*} trail
 * @param {(string: locationString, string: locationType) => void} handleClick
 * @returns
 */
const wrapLocationClick = (trail, handleClick) => {
  return e => {
    e.preventDefault();
    e.stopPropagation();
    const [locationString, locationType] = getTrailLocationInfo(trail);
    handleClick(locationString, locationType);
    return false;
  };
};

export default function CardLocation({ trail, handleClick, className, paddingRight, context }) {
  const displayName = getDisplayName(trail, context);
  if (!displayName) {
    return null;
  }

  const locationUrl = getTrailLocationUrl(trail, context ? context.languageRegionCode : null);

  // Overrides the default click behavior of the link
  let onClick;
  if (handleClick) {
    onClick = wrapLocationClick(trail, handleClick);
  } else if (locationUrl) {
    onClick = wrapEventHandler(() => {
      window.open(locationUrl, '_blank');
    });
  }

  return (
    <a
      className={`xlate-none ${styles.location} ${className}`}
      href={locationUrl}
      onClick={onClick}
      style={{ paddingRight: paddingRight || 0 }}
      title={displayName}
    >
      {displayName}
    </a>
  );
}
